// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"807a24a8","248":"e8e29a6f","319":"c3123c77","364":"1bdd835d","471":"fb1f8f6a","499":"42d6ce22","566":"fa8f1acb","583":"19d99e9d","756":"6b41daff","895":"cec5c01d","907":"a2dc7424","983":"f7f55dab"}[chunkId] + ".chunk.js";
};